<template>
  <div class="login">
    <div class="welcome">
      <h1 style="color: #ffffff; text-align: center;">密码修改</h1>
    </div>
    <div class="login-form">
      <el-form ref="user" :model="user" :rules="rules">
        <el-form-item class="login-inp" prop="password">
          <el-input
            v-model="user.password"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-inp" prop="password2">
          <el-input
            v-model="user.password2"
            type="password"
            placeholder="请输入确认密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-inp">
          <el-button style="width: 100%" type="primary" @click="passwordEdit"
            >修改密码</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 5) {
        callback(new Error("密码不能小于5位!"));
      } else if (value.length > 18) {
        callback(new Error("密码不能大于18位!"));
      } else {
        if (this.user.password2 !== "") {
          this.$refs.user.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.user.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      user: {
        password: "",
        password2: "",
        userToken: "",
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        password2: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  created: function () {
    this.userToken = window.sessionStorage.getItem("userToken");
    if (!this.userToken) {
      this.$router.push("/login");
      return;
    }
  },
  methods: {
    passwordEdit() {
      const loading = this.$loading();
      var that = this;
      this.$refs["user"].validate((valid) => {
        if (valid) {
          this.axios
            .post("/User/EditPwdByUserToken", {
              password: that.GLOBAL.aesEncrypt(this.user.password),
              userToken: this.userToken,
            })
            .then(function (response) {
              if (response.status == 200) {
                if (response.data.state == 0) {
                  that.$message.success("修改密码成功");
                  window.sessionStorage.removeItem("userToken");
                  that.$router.push("/login");
                } else {
                  that.$message.error(response.data.message);
                }
              } else {
                that.$message.error("请检查网络设置");
              }
              loading.close();
            });
        } else {
            loading.close();
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: url(../../assets/bg.png) no-repeat;
  background-size: cover;
  position: fixed;
  z-index: -10;
}
.welcome {
  width: 100%;
  margin: 25% 0;
}
.welcome img {
  width: 100%;
}
.login-inp {
  margin: 0 30px 25px 30px;
  border-radius: 25px;
}

.confirm {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 3px 4px;
  width: 70%;
  font-size: 14px;
  font-family: "Microsoft soft";
}
.confirm:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/components/PasswordEdit/Index.vue